import React from 'react';
import 'survey-core/defaultV2.css';
import { Survey } from 'survey-react-ui';
import { StylesManager, Model } from 'survey-core';
StylesManager.applyTheme("defaultV2");

export default function ViewSurveyLayout(props) {
  const surveyJson = new Model(props.survey.survey_json);
  if (!!props.surveyResults.results) {
    const results = props.surveyResults.results;
    for (const result of results) {
      const question = surveyJson.getQuestionByName(result.question.question_json.name);
      question.value = result.answer;
    }
  }
  
  const companyColors = props.companyBranding.colors;
  surveyJson.onAfterRenderSurvey.add((sender, options) => {
    const surveyElement = options.htmlElement;
    const cssVars = {
      '--primary': companyColors[0],
      '--secondary': companyColors[1],
    }
    for (const key in cssVars) {
      surveyElement.style.setProperty(key, cssVars[key]);
    }
  });
  
  // on page change, save results
  surveyJson.sendResultOnPageNext = true;
  surveyJson.onPartialSend.add((sender) => {
    props.partialCompleteFn(sender.data);
  });

  // when completed
  surveyJson.onComplete.add((sender, options) => {
    props.completeFn(sender.data);
  });

  return (
      <Survey model={surveyJson} />
  );
}